import NavIcon from "./NavIcon";

export default function TeamIcon(props) {
  return (
    <NavIcon {...props}>
      <circle cx="12" cy="5" r="2.5" />
      <circle cx="5" cy="19" r="2.5" />
      <circle cx="19" cy="19" r="2.5" />
      <path d="M12 7.5V12m0 0l-5.5 5M12 12l5.5 5" />
    </NavIcon>
  );
}
